import numeral from "numeral";
import React from "react";
import { Pie, Bar } from "react-chartjs-2";
import { useSelector } from "react-redux";
import API from "../../utils/API";
import { isBiro, satuan, singkatan_nama_perusahaan } from "../../utils/helper";
import Table from 'react-bootstrap/Table';

export default (props) => {
    const chartFilterDashboard = useSelector(
        (state) => state.chartFilterDashboard
    );
    const companies = useSelector(
        (state) => state.perusahaanReducer.listPerusahaan
    );
    const [data, setData] = React.useState([]);
    const [rawData, setRawData] = React.useState([]);
    const [legend, setLegend] = React.useState([]);

    const [isThereNegative, setIsThereNegative] = React.useState(0);
    const [total, setTotal] = React.useState(0);
    const currentYear = new Date().getFullYear();
    const user = useSelector((state) => state.main.dataUser);

    const optionsPie = {
        legend: {
            display: false
        },
        tooltips: {
            callbacks: {
                label: (tooltipItem, data) => {
                    const n = tooltipItem.index;
                    return data.labels[n];
                },
                footer: (tooltipItems, data) => {
                    const n = tooltipItems[0].index;
                    return "Rp " + numeral(data.datasets[0].data[n]).format(0, 0);
                }
            }
        }
    };
    const optionsBar = {
        responsive: true,
        legend: {
            display: false
        },
        tooltips: {
            callbacks: {
                label: (tooltipItem, data) => {
                    const n = tooltipItem.index;
                    return data.labels[n];
                },
                footer: (tooltipItems, data) => {
                    const n = tooltipItems[0].index;
                    return "Rp " + numeral(data.datasets[0].data[n]).format(0, 0);
                }
            }
        },
        scales: {
            yAxes: [
                {
                    ticks: {
                        display: true,
                        beginAtZero: true,
                        callback: function (val, index) {
                            return satuan(val);
                        }
                    }
                }
            ],
            xAxes: [
                {
                    ticks: {
                        display: false
                    }
                }
            ]
        }
    };

    const getValues = (raws) => {
        let negativeCounter = 0;
        for (const rd of raws) {
            if (rd.value === null || rd.value <= 0) negativeCounter++;
        }
        if (negativeCounter === raws.length) return raws.map((o) => o.value);
        return raws.map((o) => (o.value == null ? 0 : o.value));
    };
    const getData = async () => {
        if (companies.content.length === 0 && isBiro()) {
            var url =
                `/chart/latest-chart-legend-asset?type=${chartFilterDashboard.type}&perusahaanId=${chartFilterDashboard.bumd}`;

        } else {
            var url =
                `/chart/latest-chart-legend-asset?type=${chartFilterDashboard.type}&perusahaanId=${user.perusahaan == null ? chartFilterDashboard.bumd : user.perusahaan.id}`;
        }

        url = url.trim();
        const r = await API.get(url);
        const d = r.data;
        checkThereNegative(r.data);
        const comp = companies.content;
        const chartData = {
            labels: d.map((o) => o.perusahaanName),
            years: d.map((o) => o.year),
            valueLiabilitys: d.map((o) => o.valueLiability),
            valueEquitys: d.map((o) => o.valueEquity),
            valueAssetLancars: d.map((o) => o.valueAssetLancar),
            valueAssetTidakLancars: d.map((o) => o.valueAssetTidakLancar),
            keterangans: d.map((o) => o.keterangan),
            datasets: [
                {
                    data: getValues(d),
                    backgroundColor: isBiro()
                        ? d.map(
                            (o) => comp.filter((c) => c.id === o.perusahaanId)[0]?.color
                        )
                        : "#28a745"
                }
            ]
        };


        createDataLegend(chartData);
        setData(chartData);
        setRawData(data);
    };

    const createDataLegend = (par) => {
        if (par) {
            var arrayTitle = par.labels;
            var arrayYear = par.years;
            var arrayKeterangan = par.keterangans;
            var arrayValueLiability = par.valueLiabilitys;
            var arrayValueEquity = par.valueEquitys;
            var arrayAssetLancar = par.valueAssetLancars;
            var arrayAssetTidakLancar = par.valueAssetTidakLancars;
            var value = par.datasets[0].data;
            var bg = par.datasets[0].backgroundColor;
            var tmp = [];
            for (var i = 0; i < arrayTitle.length; i++) {
                var obj = {
                    title: arrayTitle[i],
                    year: arrayYear[i],
                    value: value[i],
                    bg: bg[i],
                    ket: arrayKeterangan[i],
                    valueLiability: arrayValueLiability[i],
                    valueEquity: arrayValueEquity[i],
                    valueAssetLancar: arrayAssetLancar[i],
                    valueAssetTidakLancar: arrayAssetTidakLancar[i],
                };
                tmp.push(obj);
            }
            setLegend(tmp);
        }
    };

    const checkThereNegative = (data) => {
        if (data) {
            var inc = 0;
            data.map((r, i) => {
                if (r.value < 0) {
                    inc++;
                    setIsThereNegative(inc);
                }
            });
        }
    };


    React.useEffect(() => {
        getData();
    }, [
        companies,
        chartFilterDashboard
    ]);


    if (!isBiro()) {
        return (
            <div className="col-md-12" style={{ marginTop: 20 }}>

                <Table striped bordered>
                    <thead className="text-center">
                        <tr>
                            <th>BUMD</th>
                            <th>Tahun</th>
                            <th>Asset Lancar</th>
                            <th>Asset Tidak Lancar</th>
                            <th>Liabilitas</th>
                            <th>Equitas</th>
                        </tr>
                    </thead>
                    <tbody>

                        {legend.map((r, i) => {
                            return (
                                <tr>
                                    <td> <div
                                        key={i}
                                        style={{
                                            marginLeft: 20,
                                            display: "flex",
                                            flexDirection: "row",
                                            alignItems: "center"
                                        }}
                                    ><div
                                            style={{
                                                backgroundColor: "#28a745",
                                                height: 10,
                                                width: 10,
                                                borderRadius: 5,
                                                marginRight: 5
                                            }}
                                        />&nbsp;{r.title}</div></td>
                                    <td className="text-center"> {r.year}</td>
                                    <td className="text-right"><strong>{satuan(r.valueAssetLancar)}</strong></td>
                                    <td className="text-right"><strong>{satuan(r.valueAssetTidakLancar)}</strong></td>
                                    <td className="text-right"><strong>{satuan(r.valueLiability)}</strong></td>
                                    <td className="text-right"><strong>{satuan(r.valueEquity)}</strong></td>
                                </tr>
                            )
                        })}
                    </tbody>
                </Table>
            </div>
        );
    }

    if (
        isThereNegative > 0 ||
        (chartFilterDashboard.bumd !== "" &&
            typeof chartFilterDashboard.bumd == "string")
    ) {
        return (
            <div className="col-md-12" style={{ marginTop: 20 }}>
                <Table striped bordered>
                    <thead className="text-center">
                        <tr>
                            <th>BUMD</th>
                            <th>Tahun</th>
                            <th>Asset Lancar</th>
                            <th>Asset Tidak Lancar</th>
                            <th>Liabilitas</th>
                            <th>Equitas</th>
                        </tr>
                    </thead>
                    <tbody>

                        {legend.map((r, i) => {
                            return (
                                <tr>
                                    <td> <div
                                        key={i}
                                        style={{
                                            marginLeft: 20,
                                            display: "flex",
                                            flexDirection: "row",
                                            alignItems: "center"
                                        }}
                                    ><div
                                            style={{
                                                backgroundColor: r.bg,
                                                height: 10,
                                                width: 10,
                                                borderRadius: 5,
                                                marginRight: 5
                                            }}
                                        />&nbsp;{r.title}</div></td>
                                    <td className="text-center"> {r.year}</td>
                                    <td className="text-right"><strong>{satuan(r.valueAssetLancar)}</strong></td>
                                    <td className="text-right"><strong>{satuan(r.valueAssetTidakLancar)}</strong></td>
                                    <td className="text-right"><strong>{satuan(r.valueLiability)}</strong></td>
                                    <td className="text-right"><strong>{satuan(r.valueEquity)}</strong></td>
                                </tr>
                            )
                        })}
                    </tbody>
                </Table>
            </div>
        );
    }
    return (
        <div className="col-md-12" style={{ marginTop: 20 }}>

            <Table striped bordered>
                <thead className="text-center">
                    <tr>
                        <th>BUMD</th>
                        <th>Tahun</th>
                        <th>Asset Lancar</th>
                        <th>Asset Tidak Lancar</th>
                        <th>Liabilitas</th>
                        <th>Equitas</th>
                    </tr>
                </thead>
                <tbody>

                    {legend.map((r, i) => {
                        return (
                            <tr>
                                <td> <div
                                    key={i}
                                    style={{
                                        marginLeft: 20,
                                        display: "flex",
                                        flexDirection: "row",
                                        alignItems: "center"
                                    }}
                                ><div
                                        style={{
                                            backgroundColor: r.bg,
                                            height: 10,
                                            width: 10,
                                            borderRadius: 5,
                                            marginRight: 5
                                        }}
                                    />&nbsp;{r.title}</div></td>
                                <td className="text-center">{r.year}</td>
                                <td className="text-right"><strong>{satuan(r.valueAssetLancar)}</strong></td>
                                <td className="text-right"><strong>{satuan(r.valueAssetTidakLancar)}</strong></td>
                                <td className="text-right"><strong>{satuan(r.valueLiability)}</strong></td>
                                <td className="text-right"><strong>{satuan(r.valueEquity)}</strong></td>
                            </tr>
                        )
                    })}
                </tbody>
            </Table>
        </div>

    );
};

